import { render, staticRenderFns } from "./kalemferibot.vue?vue&type=template&id=e1778ef0"
import script from "./kalemferibot.vue?vue&type=script&lang=js"
export * from "./kalemferibot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports